export enum CompanyUniverseSearch {
	MyConnections = 'MyConnections',
	Network = 'Network',
	MyCompanies = 'MyCompanies',
}
